import AXIOS from "@/axios";
import { removeEmptyProps } from "@/utils/constants";
import type {
  ClassesByLevelQuery,
  ClassesByLevelResponse,
  ClassViewApiResponse,
  OurClassesApiResponse,
} from "./landingClass.types";

export const getOurClassesService = async (): Promise<OurClassesApiResponse> => {
  const response = await AXIOS.get<OurClassesApiResponse>(
    "/class/api/v1/list/our-classes"
  );
  return response.data;
};

export const getClassesByLevelService = async (
  level2Id: string,
  query: ClassesByLevelQuery
): Promise<ClassesByLevelResponse> => {
  const response = await AXIOS.get<ClassesByLevelResponse>(
    `/class/api/v1/by-level/${level2Id}`,
    {
      params: removeEmptyProps({
        level1Id: query.level1Id,
        page: query.page,
        pageSize: query.pageSize,
        search: query.search,
        badge: query.badge,
        sortBy: query.sortBy,
      }),
    }
  );
  return response.data;
};

export const getClassViewService = async (
  classId: string
): Promise<ClassViewApiResponse> => {
  const response = await AXIOS.get<ClassViewApiResponse>(
    `/class/api/v1/view/${classId}`
  );
  return response.data;
};
